import Control from 'models/control';
import ControlDTO from 'models/dto/controlDTO';
import { CopilotConversationDTO } from 'models/dto/copilot/copilotConversationDTO';
import TaskDTO from 'models/dto/tasks/taskDTO';
import Task from 'models/tasks/task';
import { CopilotConversation } from '../../copilotConversation';

export class TenantProcessStateAnnualPlan {
  tasks: Task[];

  controls: Control[];

  conversation: CopilotConversation;

  constructor() {
    this.tasks = [];
    this.controls = [];
    this.conversation = new CopilotConversation();
  }
}

export class TenantProcessStateAnnualPlanDTO {
  tasks: TaskDTO[];

  controls: ControlDTO[];

  conversation: CopilotConversationDTO;

  constructor() {
    this.tasks = [];
    this.controls = [];
    this.conversation = new CopilotConversationDTO();
  }
}
